import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { LangContext } from "../../context/LangContext";
import { useGoPage } from "../../hooks/useGoPage";

import SelectLang from "../../components/SelectLang";
import Paging from "../../components/Paging";
import ModalShop from "../../components/ModalShop";

import "./style.css"

import icon_cart from '../../assets/svg/basket.svg'

function Shop() {
    const goPage = useGoPage();
    const { language, translations } = useContext(LangContext);

    const cart = useSelector(state => state.cart);
    const articlesDB = useSelector(state => state.articles);
    const headerWidth = useSelector(state => state.options.headerWidth);

    const [paging, setPaging] = useState(0);
    const [modal, setModal] = useState(null);
    const [articlesData, setArticlesData] = useState(null);

    useEffect(() => {
        const chunkSize = headerWidth < 700 ? 10 : 15;
        const chunkedData = [];

        for (let i = 0; i < articlesDB.length; i += chunkSize) {
            const chunk = articlesDB.slice(i, i + chunkSize);
            chunkedData.push(chunk);
        }

        setArticlesData(chunkedData);
        setPaging(0);
    }, [articlesDB, headerWidth]);

    return articlesDB && articlesData && (
        <div className='page page_shop'>
            <p className="title_page">
                - <span>Shop</span> -
            </p>

            <button
                className="btn_show_cart"
                onClick={() => setModal("cart")}
            >
                <p>{translations.cart}</p>
                <img src={icon_cart} alt="" />
            </button>

            <SelectLang />

            <section className="sect_articles">
                <ul className="articles_list">
                    {articlesData.length !== 0 && articlesData[paging].map((artcl, idx) => (
                        <li key={idx}>
                            <button onClick={() => goPage(`article/${artcl.title_path}`)}>
                                <div className="preview">
                                    <i style={{ backgroundImage: `url(${artcl.images[0]._url})` }}></i>
                                </div>

                                <h2>- {artcl[`title_${language}`]} -</h2>
                            </button>
                        </li>
                    ))}
                </ul>

                {articlesData.length > 1 &&
                    <Paging data={articlesData} paging={paging} setPaging={setPaging} />
                }
            </section>


            {modal && cart &&
                <ModalShop modal={modal} setModal={setModal} />
            }
        </div>
    );
}

export default Shop;